import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "discount-details"
};
var _hoisted_2 = {
  class: "discount-content"
};
var _hoisted_3 = {
  class: "goods-group"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  key: 0,
  class: "number-of-pieces"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  key: 0,
  class: "preferential-price"
};
var _hoisted_10 = {
  class: "price-title"
};
var _hoisted_11 = {
  class: "bold"
};
var _hoisted_12 = {
  class: "price"
};
var _hoisted_13 = {
  alt: ""
};
var _hoisted_14 = {
  class: "price-size"
};
var _hoisted_15 = {
  class: "price"
};
var _hoisted_16 = {
  alt: ""
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1);
var _hoisted_18 = {
  alt: ""
};
var _hoisted_19 = {
  class: "preferential-price"
};
var _hoisted_20 = {
  class: "price-title m-b-12"
};
var _hoisted_21 = {
  class: "price bold"
};
var _hoisted_22 = {
  class: "default-color price-size"
};
var _hoisted_23 = {
  class: "preferential-price"
};
var _hoisted_24 = {
  class: "price-title"
};
var _hoisted_25 = {
  class: "bold"
};
var _hoisted_26 = {
  class: "default-color text-strikethrough price-size"
};
var _hoisted_27 = {
  class: "price bold"
};
var _hoisted_28 = {
  class: "preferential-price"
};
var _hoisted_29 = {
  class: "in-total"
};
var _hoisted_30 = {
  class: "bold total-text"
};
var _hoisted_31 = {
  class: "total-price price bold"
};
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import cartUtils from '../cartUtils';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import { imageCutEdgeAndSetSize } from '@/utils/common';
var PRODUCT_ROW_MAX_LENGTH = 4;
export default {
  __name: 'DiscountDetails',
  props: ['marginBottom'],
  setup(__props) {
    useLess('views/cart/components/DiscountDetails.less');
    var DEAL_TYPES = constants.Common.DEAL_TYPES;
    var UPARROW = imageLink.UPARROW,
      SELECTED = imageLink.SELECTED,
      DOWN_ARROW = imageLink.DOWN_ARROW,
      NOT_SELECTED = imageLink.NOT_SELECTED;
    var _useI18n = useI18n(),
      t = _useI18n.t;

    // View all products
    var showAllProducts = ref(false);
    var itemChecked = true;
    // View larger image display
    var seeLargeImgShow = ref(false);
    // The picture shown by the big picture
    var seeImages = ref([]);
    var productslist = ref([]);
    var dotdPrice = ref([]);
    // Special selling price
    var dealPrice = ref([]);
    // No discount products
    var noDiscountProducts = ref([]);

    // Shopping cart data processing function
    var _cartUtils$cartState = cartUtils.cartState,
      selectList = _cartUtils$cartState.selectList,
      isShowDetail = _cartUtils$cartState.isShowDetail,
      calculatedAllPrice = _cartUtils$cartState.calculatedAllPrice;
    watch(() => isShowDetail, () => {
      itemChecked = true;
    });
    watch(selectList, () => {
      productslist.value = selectList.value;
      dotdPrice.value = [];
      dealPrice.value = [];
      noDiscountProducts.value = [];
      selectList.value.forEach(item => {
        var _item$dealOffer, _item$dealOffer2;
        // Special price information display
        if (((_item$dealOffer = item.dealOffer) === null || _item$dealOffer === void 0 ? void 0 : _item$dealOffer.dealType) === DEAL_TYPES.DEAL_OF_THE_DAY) {
          dotdPrice.value.push(item);
          // Special price information display
        } else if (((_item$dealOffer2 = item.dealOffer) === null || _item$dealOffer2 === void 0 ? void 0 : _item$dealOffer2.dealType) === DEAL_TYPES.BEST_DEAL) {
          dealPrice.value.push(item);
        } else {
          noDiscountProducts.value.push(item);
        }
      });
    }, {
      immediate: true
    });
    var splitDeductionAmount = str => {
      return str.split(t('modules.cart.DEDUCTION'))[1].split(t('common.CURRENCY_UNIT_TEXT'))[0];
    };
    var onClose = () => {
      isShowDetail.value = false;
    };
    var onUnfoldAll = () => {
      itemChecked = true;
      showAllProducts.value = !showAllProducts.value;
    };
    var onViewLoargeImage = url => {
      seeImages.value = [];
      seeLargeImgShow.value = true;
      seeImages.value.push(url);
    };
    return (_ctx, _cache) => {
      var _component_van_checkbox = _resolveComponent("van-checkbox");
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_van_image_preview = _resolveComponent("van-image-preview");
      var _directive_lazy = _resolveDirective("lazy");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_popup, {
        show: _unref(isShowDetail),
        closeable: "",
        round: "",
        position: "bottom",
        style: _normalizeStyle({
          height: '82%',
          marginBottom: __props.marginBottom + 'px'
        }),
        "close-icon": "cross",
        "close-on-popstate": true,
        onClose: onClose,
        class: "discount-details-popup"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h2", null, _toDisplayString(_ctx.$t('modules.cart.VIEW_DETAILS')), 1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          class: "selected-goods",
          style: _normalizeStyle([showAllProducts.value ? 'height: auto' : ''])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productslist.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.asin,
            class: "image-content"
          }, [_createVNode(_component_van_checkbox, {
            class: "radio",
            modelValue: _unref(itemChecked),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(itemChecked) ? itemChecked.value = $event : itemChecked = $event),
            "checked-color": "#eb1745"
          }, {
            icon: _withCtx(checkboxProps => [_createElementVNode("img", {
              src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
            }, null, 8, _hoisted_4)]),
            _: 1
          }, 8, ["modelValue"]), _withDirectives(_createElementVNode("img", {
            onClick: $event => onViewLoargeImage(item.mainImageUrl),
            alt: ""
          }, null, 8, _hoisted_5), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(item.mainImageUrl)]]), item.count > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, " x" + _toDisplayString(item.count), 1)])) : _createCommentVNode("", true)]);
        }), 128))], 4), productslist.value.length > PRODUCT_ROW_MAX_LENGTH ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [!showAllProducts.value ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "open-all",
          onClick: onUnfoldAll
        }, [_createTextVNode(_toDisplayString(_ctx.$t('common.selected') + productslist.value.length + _ctx.$t('common.numberOfGoods')) + " ", 1), _createElementVNode("img", {
          class: "Arrow",
          src: _unref(DOWN_ARROW),
          alt: ""
        }, null, 8, _hoisted_7)])) : (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "open-all",
          onClick: onUnfoldAll
        }, [_createTextVNode(_toDisplayString(_ctx.$t('common.selected') + productslist.value.length + _ctx.$t('common.numberOfGoods')) + " " + _toDisplayString(_ctx.$t('modules.cart.PACK_UP')) + " ", 1), _createElementVNode("img", {
          class: "Arrow",
          src: _unref(UPARROW),
          alt: ""
        }, null, 8, _hoisted_8)]))], 64)) : _createCommentVNode("", true)]), dotdPrice.value.length || dealPrice.value.length || noDiscountProducts.value.length ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [_createElementVNode("li", _hoisted_10, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.TOTAL_AMOUNT_OF_PRODUCTS')), 1), _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('common.currencyUnit') + (Number(_unref(calculatedAllPrice).totalAmount) + Number(_unref(calculatedAllPrice).discount || 0)).toFixed(2)), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dotdPrice.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.asin
          }, [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('common.DOTDPrice')), 1), _createElementVNode("div", null, [_withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(item.mainImageUrl)]]), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('common.currencyUnit') + (item.newOurPrice || item.ourPrice).toFixed(2)), 1)])]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealPrice.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.asin
          }, [_createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('common.salePrice')), 1), _createElementVNode("div", null, [_withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(item.mainImageUrl)]]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.currencyUnit') + (item.newOurPrice || item.ourPrice).toFixed(2)), 1)])]);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noDiscountProducts.value, item => {
          return _openBlock(), _createElementBlock("li", {
            key: item.asin
          }, [_hoisted_17, _createElementVNode("div", null, [_withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [[_directive_lazy, _unref(imageCutEdgeAndSetSize)(item.mainImageUrl)]]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.currencyUnit') + (item.newOurPrice || item.ourPrice).toFixed(2)), 1)])]);
        }), 128))])) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_19, [_createElementVNode("li", _hoisted_20, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.PROMOTIONAL_DEDUCTION')), 1), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_21, " -" + _toDisplayString(_ctx.$t('common.currencyUnit') + Number(_unref(calculatedAllPrice).discount).toFixed(2)), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(calculatedAllPrice).promotionList, promotion => {
          return _openBlock(), _createElementBlock("li", {
            key: promotion.encryptedPromotionId
          }, [_createElementVNode("span", null, _toDisplayString(promotion.shortMerchandisingMessage), 1), _createElementVNode("span", _hoisted_22, " -" + _toDisplayString(splitDeductionAmount(promotion.shortMerchandisingMessage)), 1)]);
        }), 128))]), _createElementVNode("ul", _hoisted_23, [_createElementVNode("li", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('modules.cart.SHIPPING_FEE_SAVING')), 1), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_26, _toDisplayString('+' + _ctx.$t('common.currencyUnit') + _unref(calculatedAllPrice).shippingDiscount), 1), _createElementVNode("span", _hoisted_27, "   " + _toDisplayString(_ctx.$t('common.currencyUnit') + '0.00'), 1)])])]), _createElementVNode("ul", _hoisted_28, [_createElementVNode("li", _hoisted_29, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('modules.cart.TOTAL_AMOUNT')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.cart.EXCLUDE_SHIPPING_TAX')), 1)]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('common.currencyUnit') + Number(_unref(calculatedAllPrice).totalAmount).toFixed(2)), 1)])])])])])]),
        _: 1
      }, 8, ["show", "style"]), _createVNode(_component_van_image_preview, {
        show: seeLargeImgShow.value,
        "onUpdate:show": _cache[1] || (_cache[1] = $event => seeLargeImgShow.value = $event),
        images: seeImages.value,
        showIndex: false
      }, null, 8, ["show", "images"])], 64);
    };
  }
};